module.exports = __webpack_public_path__ + "static/media/hero-pilot-tall-v2.32402578.png";